import React from 'react'

/**
 * Textarea — multi-line text field. Vertically resizable, comfortable
 * line-height. Used for project access lists, longer notes.
 */
export function Textarea({ className = '', ...rest }) {
  return <textarea className={className} {...rest} />
}
